import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, X, HelpCircle } from 'lucide-react';

const SupportWidget = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 2000); // 2 seconds

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <div className="premium-support-widget">
      {open && (
        <div className="premium-support-menu">
          <a
            href="https://wa.me/+917039034000"
            target="_blank"
            rel="noopener noreferrer"
            className="premium-support-button whatsapp"
          >
            <MessageCircle size={18} />
            WhatsApp
          </a>
          <a href="tel:70390 34000" className="premium-support-button call">
            <Phone size={18} />
            Call Now
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="premium-support-toggle"
        aria-label="Support"
      >
        {open ? <X size={30} /> : <HelpCircle size={30} />}
      </button>
    </div>
  );
};

export default SupportWidget;
